/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BindCategoryEnum } from './bindCategoryEnum';
import { ConnectionstatusEnum } from './connectionstatusEnum';


export interface RealTimeActiveBindDto { 
    bindingRouteName?: string;
    bindingGroupKey?: string;
    hostIp?: string;
    port?: string;
    systemId?: string;
    connectionStatus: ConnectionstatusEnum;
    connectionStatusId: number;
    dateUpdated: Date;
    bindCategory: BindCategoryEnum;
    bindCategoryId: number;
}
